import CustomCheckBoxGroup from "../organism/custom-checkbox-group.organism";
import { normalizeOptions } from "../../utils/generalFormUtils";

const InputCheckBoxGroup = ({ question, id, answer, onAnswerChange }) => {
  const options = normalizeOptions(question.options);
  const selectedValues = Array.isArray(answer) ? answer : [];

  return (
    <CustomCheckBoxGroup
      label={question.label || "Pregunta sin título"}
      options={options}
      selectedValues={selectedValues}
      onChange={onAnswerChange}
      id={`question-${id}`} 
    />
  );
};

export default InputCheckBoxGroup;
